import { render, staticRenderFns } from "./fyndware-info.vue?vue&type=template&id=1ba4db5e&"
import script from "./fyndware-info.vue?vue&type=script&lang=js&"
export * from "./fyndware-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports